// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field-outline-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 16px;
  padding: 6px 12px;
  border-radius: 4px;
  font-family: Roboto, Arial, sans-serif;
  border-bottom: 1px solid rgba(0, 0, 0, 0.23);
}

.mat-form-field-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 4px;
}

.gmp-container {
  display: block;
  width: 100%;
}

::ng-deep gmpx-place-autocomplete {
  display: block;
  width: 100%;
  font-size: 16px;
  font-family: inherit;
  padding: 6px 0;
  border: none;
  outline: none;
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/app/common/google-places-autocomplete/google-places-autocomplete.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;EACA,4CAAA;AACF;;AAEA;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AACF","sourcesContent":[".mat-form-field-outline-wrapper {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-top: 16px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-family: Roboto, Arial, sans-serif;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.23);\n}\n\n.mat-form-field-label {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.6);\n  margin-bottom: 4px;\n}\n\n.gmp-container {\n  display: block;\n  width: 100%;\n}\n\n::ng-deep gmpx-place-autocomplete {\n  display: block;\n  width: 100%;\n  font-size: 16px;\n  font-family: inherit;\n  padding: 6px 0;\n  border: none;\n  outline: none;\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
